import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import PendingStatusPopup from './PendingStatusPopup';
import BlockedStatusPopup from './BlockedStatusPopup';

const UserStatusHandler = () => {
  const { 
    userStatus, 
    showPendingPopup, 
    showBlockedPopup, 
    setShowPendingPopup, 
    setShowBlockedPopup, 
    handleBlockedLogout,
    logout
  } = useAuth();
  const { theme, currentThemeName } = useTheme();

  // Don't render anything if user is not authenticated or has no status issues
  if (!userStatus || userStatus === 'active') {
    return null;
  }

  return (
    <>
      {/* Pending Status Popup */}
      {showPendingPopup && (
        <PendingStatusPopup
          isOpen={showPendingPopup}
          onClose={() => setShowPendingPopup(false)}
          onLogout={logout}
          theme={theme}
          currentThemeName={currentThemeName}
        />
      )}

      {/* Blocked Status Popup */}
      {showBlockedPopup && (
        <BlockedStatusPopup
          isOpen={showBlockedPopup}
          onClose={() => setShowBlockedPopup(false)}
          onLogout={handleBlockedLogout}
          theme={theme}
          currentThemeName={currentThemeName}
        />
      )}
    </>
  );
};

export default UserStatusHandler;
